<template>
  <div class="style-fullWidth" :style="'display:' + display + ';'" v-if="selectedCapQuyTrinhButton">
    <div class="style-fullWidth capQuyTrinhButtonDiv">
      <el-dropdown trigger="click">
        <el-button class="capQuyTrinhButton">
          {{ selectedCapQuyTrinhButton.label }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in capQuyTrinhButtons" :key="item.id">
            <div
              @click="capQuyTrinhButtonsClicked(item)"
              class="style-fullWidth"
            >
              {{ item.label }}
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <FullCalendar
      ref="calendarRef"
      class="margin-top-5"
      locale="vi"
      :firstDay="1"
      :height="height"
      :allDaySlot="false"
      :handleWindowResize="true"
      :resourceLabelText="'Danh sách phòng'"
      :noEventsMessage="'Không có dữ liệu'"
      :plugins="calendarPlugins"
      :defaultView="defaultView"
      :header="header"
      :custom-buttons="customButtons"
      :buttonText="buttonText"
      :events="listRequestAccepted2"
      :eventRender="eventRender"
      @eventDestroy="eventDestroy"
      @eventClick="viewDetail"
    />
  </div>
</template>

<script>
  import listPlugin from "@fullcalendar/list";
  import FullCalendar from "@fullcalendar/vue";
  import moment from "moment";
  import Vue from "vue";
  import constants from "../../../constants";
  import h from "../../../services/h";
  import hanhchinhService from "../../../services/hanhchinhService";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import utils from "../../../services/utils";
  import FullCalendarLichtuanRow from "./fullCalendar-lichtuan-row";

  const FullCalendarLichtuanRowClass = Vue.extend(FullCalendarLichtuanRow);

  export default {
    name: "hc-calendar-full-calendar",
    props: ["height", "availableFlows", "display"],

    components: {
      FullCalendar
    },

    data() {
      return {
        capQuyTrinhButtons: [],
        selectedCapQuyTrinhButton: null,
        calendarPlugins: [listPlugin],
        defaultView: "listWeek",
        header: {
          left: "prev,today,next",
          center: null,
          right: "listDay,listWeek"
        },
        customButtons: {},
        buttonText: {
          today: "Hôm nay",
          listWeek: "Tuần",
          listDay: "Ngày"
        },
        listRequestAccepted2: [], //list hiển thị cuối cùng dựa vào list listRequestAccepted
        deptId: null,
        groupFilters: [],
        flowCode: "LICH_TUAN",
        eventsObj: {},
        searchKeyTabProcessed: null,
      };
    },

    watch: {
      availableFlows() {
        this.availableFlowsChanged();
      }
    },

    created() {
    },

    methods: {

      async doSearch({keyword}) {
        this.searchKeyTabProcessed = keyword;
        await this.reloadPage();
        this.initListRequestAccepted2();
      },

      getAcceptedRequests(
        startDate,
        endDate,
        keyword,
        deptId,
        pageable,
        approveStatus
      ) {
        return hanhchinhService
          .getAcceptedRequestsIncludeCoopDepts(
            startDate,
            endDate,
            keyword,
            deptId,
            pageable,
            approveStatus
          )
          .then(response => {
            let items = response.data.hcCaseCalendars;
            items.forEach(item => {
              this.listRequestAccepted.push({
                id: item.hcCaseCalendarView.caseMasterId,
                title: item.hcCaseCalendarView.meetingTitle,
                meetingPlace: item.hcCaseCalendarView.meetingPlace,
                meetingContent: item.hcCaseCalendarView.meetingContent,
                chairedUnit: item.hcCaseCalendarView.chairedUnit,
                leaderNames: item.hcCaseCalendarView.leaderNames,
                listHcCoopDepts: item.hcCoopDepts,
                otherInvolved: item.hcCaseCalendarView.otherInvolved
                  ? item.hcCaseCalendarView.otherInvolved
                  : "",
                createTime:
                  `` +
                  moment(item.hcCaseCalendarView.createTime).format(
                    "DD/MM/YYYY HH:mm"
                  ),
                start: moment(item.hcCaseCalendarView.startTime).format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
                end: moment(item.hcCaseCalendarView.endTime).format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
                startTime_: item.hcCaseCalendarView.startTime,
                endTime_: item.hcCaseCalendarView.endTime,
                isDay:
                  new Date(item.hcCaseCalendarView.startTime).getHours() < 12,
                caseMasterId: item.hcCaseCalendarView.caseMasterId,
                hcCaseCalendarId: item.hcCaseCalendarView.id,
                parentDeptName: item.hcCaseCalendarView.parentDeptName,
                hcCaseCalendarView: item.hcCaseCalendarView
              });
            });
          });
      },

      reloadPage() {
        this.listRequestAccepted = [];
        let monday;
        let sunday;
        let approveStatus = null;
        monday = moment()
          .subtract(1, "months")
          .startOf("isoWeek")
          .toDate()
          .getTime();
        sunday = moment()
          .add(1, "months")
          .endOf("isoWeek")
          .toDate()
          .getTime();
        let pageable = {size: 1000};
        return this.getAcceptedRequests(
          monday,
          sunday,
          this.searchKeyTabProcessed,
          this.deptId,
          pageable,
          approveStatus
        );
      },

      initCustomButtons() {
        this.capQuyTrinhButtons = [];
        h.each(this.availableFlows, item =>
          this.capQuyTrinhButtons.push({
            id: item.deptId,
            deptId: item.deptId,
            label: item.deptName,
            type: "deptId"
          })
        );
        this.capQuyTrinhButtons.push({
          id: "viewSharedOnlyButton",
          deptId: null,
          label: "Lịch tuần được chia sẻ",
          type: "shareButton"
        });
        this.selectedCapQuyTrinhButton = h.find(
          this.capQuyTrinhButtons,
          item => item.id === this.deptId
        );
      },

      async availableFlowsChanged() {
        if (this.availableFlows && this.availableFlows.length)
          this.deptId = this.availableFlows[0].deptId;
        this.initCustomButtons();
        await this.initGroupFilters();
        await this.reloadPage();
        this.initListRequestAccepted2();
      },

      initListRequestAccepted2() {
        this.listRequestAccepted2 = hanhChinhUtils.initListRequestAccepted2(
          this.listRequestAccepted
        );
      },

      /**
       * khởi tạo danh sách filter ở đây là để tránh phải load lại dữ liệu nhiều lần;
       * @returns {*}
       */
      initGroupFilters() {
        return (this.deptId === constants.TCT_DEPT_ID
            ? utils.initGroupFilters(
              hcCaseCalendarUserView => hcCaseCalendarUserView.userDeptRoleId
            )
            : Promise.resolve([])
        ).then(groupFilters => (this.groupFilters = groupFilters));
      },

      async capQuyTrinhButtonsClicked(capQuyTrinhButton) {
        if (this.selectedCapQuyTrinhButton.id !== capQuyTrinhButton.id) {
          this.selectedCapQuyTrinhButton = capQuyTrinhButton;
          this.deptId = capQuyTrinhButton.deptId;
          await this.initGroupFilters();
          await this.reloadPage()
          this.initListRequestAccepted2();
          this.$emit("capQuyTrinhDeptIdChanged", {deptId: this.deptId});
        }
      },

      viewDetail(e) {
        let caseMasterId = e.event.id;
        this.$emit("viewDetail", {caseMasterId});
      },

      eventDestroy(e) {
        let id = parseInt(e.el.getAttribute("data-vue-id"));
        if (this.eventsObj[id]) {
          this.eventsObj[id].$destroy(true);
        }
      },

      eventRender(e) {
        let data = e.event.extendedProps;
        let component = new FullCalendarLichtuanRowClass({
          propsData: {
            meetingTitle: e.event.title,
            meetingPlace: data.meetingPlace,
            parentDeptName: data.parentDeptName,
            // leaderNames: data.leaderNames,
            chairedUnit: data.chairedUnit,
            cooperateDeptNames: h.collect(
              data.listHcCoopDepts,
              item => item.cooperateDeptName
            ),
            meetingContent: data.meetingContent,
            otherInvolved: data.otherInvolved,
            caseMasterId: data.caseMasterId,
            hcCaseCalendarId: data.hcCaseCalendarId,
            groupFilters: this.groupFilters,
            isViewShareMode:
              this.selectedCapQuyTrinhButton.type === "shareButton",
            hcCaseCalendarView: data.hcCaseCalendarView
          }
        });
        component.$mount();
        this.eventsObj[component._uid] = component;
        //assign created component to our eventObj with uuid as key (to destroy in future)
        this.eventsObj[component._uid] = component;
        //set data-vue="{id}"
        //append our compiled component to .fc-component
        e.el.setAttribute("data-vue-id", component._uid);
        e.el.lastElementChild.childNodes[0].remove();
        e.el.lastElementChild.appendChild(component.$el);
        if (data.isDay) {
          e.el.firstElementChild.style.borderLeftWidth = "10px";
          e.el.firstElementChild.style.borderLeftColor = "#f5c533";
          e.el.cells[1].innerHTML = `<div style="color:#f5c533;">Sáng</div>`;
        } else {
          e.el.firstElementChild.style.borderLeftWidth = "10px";
          e.el.firstElementChild.style.borderLeftColor = "#007aff";
          e.el.cells[1].innerHTML = `<div style="color:#007aff;">Chiều</div>`;
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/hc-calendar-full-calendar.vue